module.exports = __webpack_public_path__ + "static/media/pasticceria_1.ee8c5096.jpg";